import { Menu, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Trip, Vehicle } from '../../store/config/types';
import './TripsDnd.styles.scss';
import { convertConstantLiteralToNormal, getVehicleDisplayName } from '../../utils/string.helpers';
import PieProgress from '../PieProgress/PieProgress';
import { Error } from '@material-ui/icons';
import { VehicleStatus } from '../../store/config/enums/vehicle.enum';

export default function VehicleSelector(props: {
  index: number;
  trip?: Trip;
  vehicleId?: number;
  vehicles: Vehicle[];
  editable?: boolean;
  /* eslint-disable */
  onChange?: (tripIndex: number, vehicleId: number | undefined) => boolean;
  /* eslint-enable */
}) {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [selectedId, setSelectedId] = useState<number | undefined>(props.vehicleId);

  const open: boolean = element ? true : false;
  useEffect(() => {
    setSelectedId(props.vehicleId);
  }, [props.vehicleId]);
  const handleElementClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    setElement(event.currentTarget);
  };
  const handleMenuClose = () => {
    setElement(null);
  };
  const handleSelectMenu = (vehicleId: number | undefined) => {
    const doChange: boolean = props.onChange ? props.onChange(props.index, vehicleId) : true;
    if (doChange) {
      setSelectedId(vehicleId);
    }
    handleMenuClose();
  };

  const getVehicleNameById = (vehicleId: number | undefined) =>
    getVehicleDisplayName(props.vehicles?.find((v) => v.vehicleId === vehicleId));
  const packCount = props.trip?.tripStops.reduce((total, s, idx) => (idx ? total + (s.packageCount ?? 1) : 0), 0);
  const utilization = props.trip?.vehicle?.capacity ? ((packCount ?? 0) / props.trip.vehicle.capacity) * 100 : 0;
  return (
    <div className="vehicle-selector" key={`vehicle-selector-${props.index}`} style={{ cursor: 'pointer' }}>
      <PieProgress
        value={utilization}
        size={12}
        color="#4CAF50"
        title={`${packCount} / ${props.trip?.vehicle?.capacity ?? 1} Packages`}
      />
      <span
        className={`vehicle-selector-link${selectedId ? '' : ' empty'}`}
        onClick={props.editable ?? true ? handleElementClick : () => {}}
      >
        {getVehicleNameById(selectedId) || '[Select one vehicle]'}
      </span>
      <Menu id="couriers-menu" anchorEl={element} open={open} onClose={handleMenuClose}>
        <MenuItem
          key={`vehicle-menu-item-0`}
          onClick={() => {
            handleSelectMenu(undefined);
          }}
        >
          <span className="none-menu-item">[None]</span>
        </MenuItem>
        {props.vehicles.map((vehicle) => (
          <MenuItem
            key={`courier-menu-item-${vehicle.vehicleId}`}
            onClick={() => {
              handleSelectMenu(vehicle.vehicleId);
            }}
            title={convertConstantLiteralToNormal(vehicle.status)}
          >
            {vehicle.status !== VehicleStatus.AVAILABLE && (
              <Error style={{ width: 16, color: 'orange', marginRight: 4 }} />
            )}
            {getVehicleNameById(vehicle.vehicleId)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
